import Metadata from '../../requests/apa/Metadata';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Utils from './../../utils/Utils';
import { LocalConfig } from '../../requests/apa/local';
import appConfigJson from '../../containers/App/config.json';

// Reuses App/config.json's own enable_ott_experience entry: same key, single source of truth.
const appLocalConfig = new LocalConfig(appConfigJson);

/**
 * @deprecated Since version 0.57.1 Will be deleted in version 1.0.1 Use enable_ott_experience.
 */
let enable_ptv_by_payment = true;
let enable_ott_experience = false;

const init = function() {
  const meta = Metadata.get(
    'enabled_ptv_by_payment',
    '{"default":{"enable":false}, "peru": {"enable": true}}'
  );
  const objectMeta = JSON.parse(meta);
  var _region = DeviceStorage.getItem('region');
  const value = objectMeta[_region] ? objectMeta[_region] : objectMeta['default'];
  if (value && typeof value == 'object') {
    enable_ptv_by_payment = value.enable;
  }

  enable_ott_experience = getEnableOttExperience();
};

const getEnableOttExperience = function () {
  return appLocalConfig.get('enable_ott_experience', { enable: false }).enable;
}

/**
 * @deprecated Since version 0.57.1 Will be deleted in version 1.0.1 Use isEnableOttExperience.
 */
const isEnablePtvByPayment = function() {
  return enable_ptv_by_payment;
};

const isEnableOttExperience = function() {
  return enable_ott_experience;
}

const disableTmpByMethod = function() {
  let tmp = true;
  if (isEnableOttExperience()) {
    if (
      DeviceStorage.getItem('fromAuthDevice') &&
      DeviceStorage.getItem('fromAuthDevice') !== 'true'
    ) {
      tmp = false;
    }
  }
  return tmp;
};

const LoadPtv = {
  init,
  isEnablePtvByPayment,
  isEnableOttExperience,
  disableTmpByMethod
};

export default LoadPtv;



// WEBPACK FOOTER //
// ./src/AAF/LoaderExp/LoadPtv.js